<div class="data-consent" *ngIf="globalContent && want | async">
  <div class="data-consent__container">
    <p>
      {{ globalContent?.fields.priceChangeConsentTextAssets | findResource: 'priceChangeConsent.description' }}
      <a [routerLink]="globalContent?.fields.priceChangeConsentLink.fields.link" target="_blank">
        {{ globalContent?.fields.priceChangeConsentLink.fields.title }}</a
      >
    </p>
    <button (click)="giveConsent()">
      {{ globalContent?.fields.priceChangeConsentTextAssets | findResource: 'priceChangeConsent.cta' }}
    </button>
  </div>
</div>
